
// export const baseURL = process.env['REACT_APP_RHOMBU_API_BASEURL'];
import axios, { AxiosInstance } from "axios";

export const baseURL = `${process.env.REACT_APP_RHOMBU_BACKEND_URL}/api/v1`;

export const axiosInstance: AxiosInstance = axios.create({
    baseURL,
    withCredentials: true,
});

export const refreshAxiosInstance: AxiosInstance = axios.create({
    baseURL,
    withCredentials: true,
});

